import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import { grantAuthSshd, revokeAuth, parseJwt } from '../services/auth';
// import { grantAuthSshd, grantAuthCnpj, revokeAuth, parseJwt } from '../services/auth';
import Project from '../models/Project';

Vue.use(Vuex);

const initialUser = JSON.parse(sessionStorage.getItem('Orcamento:token'));

export default new Vuex.Store({
  state: {
    toastAlert: {
      visibility: false,
      type: 'error',
      message: 'Tivemos um problema inesperado. Tente novamente.',
    },
    token: initialUser,
    realTokenDecoded: {},
    status: initialUser ? { loggedIn: true } : { loggedIn: false },
    project: new Project(),
    originalProject: new Project(),
    originalPrices: [],
    originalFiles: [],
    loading: false,
    loadingDataTable: false,
    startCounting: undefined,
    expiredSession: undefined,
    leaveSession: undefined,
    // isCnpj: false,
    isAdmin: false,
    isManager: false,
  },

  mutations: {
    toggleToastAlert(state, toaster) {
      if (toaster && toaster.type) {
        state.toastAlert.type = toaster.type;
      }
      if (toaster && toaster.message) {
        state.toastAlert.message = toaster.message;
      }
      state.toastAlert.visibility = toaster.visibility;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    loginSuccess(state, token) {
      state.token = token;
      state.status.loggedIn = !!token;
    },
    DECODED_SUCESS(state, tokenDecoded) {
      state.realTokenDecoded = tokenDecoded;
    },
    logout(state) {
      state.token = null;
      state.status.loggedIn = !!state.token;
    },
    editProject(state, project) {
      state.project = project;
    },
    saveOriginalProject(state, project) {
      state.originalProject = project;
    },
    saveOriginalPrices(state, prices) {
      state.originalPrices = prices;
    },
    saveOriginalFiles(state, files) {
      state.originalFiles = files;
    },
    loading(state, status) {
      state.loading = status;
    },
    loadingDataTable(state, status) {
      state.loadingDataTable = status;
    },
    monitorToken(state, timer) {
      state.startCounting = timer;
    },
    lastCallSession(state, lastCall) {
      state.expiredSession = lastCall;
    },
    endSession(state, close) {
      state.leaveSession = close;
    },
    stopMonitor(state) {
      clearTimeout(state.startCounting);
      clearTimeout(state.expiredSession);
      clearTimeout(state.leaveSession);
    },
    // isCnpj(state, status) {
    //   state.isCnpj = status;
    // },
    isAdmin(state, status) {
      state.isAdmin = status;
    },
    isManager(state, status) {
      state.isManager = status;
    },
  },

  actions: {
    toggleToastAlert({ commit }, payload) {
      const toaster = payload;

      toaster.visibility = true;
      commit('toggleToastAlert', toaster);

      setTimeout(() => {
        toaster.visibility = false;
        commit('toggleToastAlert', toaster);
      }, 5000);
      setTimeout(() => {
        if (toaster) toaster.type = 'error';
        if (toaster) toaster.message = 'Tivemos um problema inesperado. Tente novamente.';
        commit('toggleToastAlert', toaster);
      }, 6000);
    },
    async login({ commit, dispatch }, sshdUser) {
      const token = await grantAuthSshd(sshdUser);
      commit('loginSuccess', token);
      dispatch('monitorToken');
    },
    // async loginPublic({ commit, dispatch }, cnpjUser) {
    //   const token = await grantAuthCnpj(cnpjUser);
    //   commit('loginSuccess', token);
    //   dispatch('monitorToken');
    // },
    async decodeTokenAction({ commit }, token) {
      const tokenDecoded = await parseJwt(token);

      commit('isAdmin', false);
      commit('isManager', false);

      tokenDecoded.profiles.forEach(profile => {
        if (profile.sis_sgsistema == "OrcamentoParticipativo") {
          if (profile.per_dcperfil == "Admin") {
            commit('isAdmin', true);
          }
          if (profile.per_dcperfil == "Manager") {
            commit('isManager', true);
          }
          else {
            commit('isManager', false);
            commit('isAdmin', false);
          }
        }
      });
      commit('DECODED_SUCESS', tokenDecoded);
    },
    logout({ commit, dispatch }) {
      revokeAuth();
      dispatch('stopMonitor');
      commit('logout');
    },
    editProject({ commit }, project) {
      commit('editProject', project);
    },
    saveOriginalProject({ commit }, project) {
      commit('saveOriginalProject', project);
    },
    saveOriginalPrices({ commit }, prices) {
      commit('saveOriginalPrices', prices);
    },
    saveOriginalFiles({ commit }, files) {
      commit('saveOriginalFiles', files);
    },
    loading({ commit }, status) {
      commit('loading', status);
    },
    loadingDataTable({ commit }, status) {
      commit('loadingDataTable', status);
    },
    monitorToken({ commit, dispatch }) {
      const almostOneHour = 60 * 60 * 1000 - 17000;

      const timer = setTimeout(() => {
        dispatch('toggleToastAlert', {
          type: 'warning',
          message: 'Sessão expira em 15 segundos. Salve seu trabalho.',
        });

        dispatch('lastCallSession', 15000);
      }, almostOneHour);

      commit('monitorToken', timer);
    },
    lastCallSession({ commit, dispatch }, miliseconds) {
      const lastCall = setTimeout(() => {
        dispatch('toggleToastAlert', {
          message: `Sua sessão expirou.\nFaça login novamente.`,
        });

        dispatch('endSession', 2000);
      }, miliseconds);

      commit('lastCallSession', lastCall);
    },
    endSession({ commit, dispatch }, miliseconds) {
      const close = setTimeout(() => {
        dispatch('logout');
        router.push('/login');
      }, miliseconds);

      commit('endSession', close);
    },
    stopMonitor({ commit }) {
      commit('stopMonitor');
    },
    // isCnpj({ commit }, status) {
    //   commit('isCnpj', status);
    // },
    isAdmin({ commit }, status) {
      commit('isAdmin', status);
    },
    isManager({ commit }, status) {
      commit('isManager', status);
    },
  },
});
